import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	border-bottom: 1px solid ${({ theme }) => theme.gray[200]};
`;

export const Divider = styled.div`
	width: 1px;
	background-color: ${({ theme }) => theme.gray[200]};
`;

export const SidebarToggleWrapper = styled.div``;

export const Tabs = styled.div`
	display: flex;
`;

interface TabProps {
	active: boolean;
}

export const Tab = styled.button<TabProps>`
	// layout
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 8px 12px;
	height: 100%;
	// style
	color: ${({ active, theme }) => (active ? theme.gray[1000] : theme.gray[700])};
	background: ${({ active, theme }) => (active ? theme.gray[100] : `transparent`)};
	border: none;
	cursor: pointer;
	font-size: 12px;
	font-weight: 500;
	transition: color 0.2s ease-in-out, border-color 0.2s ease-in-out,
		background-color 0.2s ease-in-out;

	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;

	&:hover {
		background-color: ${({ theme }) => theme.gray[200]};
		color: ${({ theme }) => theme.gray[1000]};
	}
`;
